"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (palette) {
    return {
        colorPrimary: { color: palette.primary.main + " !important" },
        colorPrimaryLight: { color: palette.primary.light + " !important" },
        colorPrimaryDark: { color: palette.primary.dark + " !important" },
        colorPrimaryContrast: { color: palette.primary.contrastText + " !important" },
        colorSecondary: { color: palette.secondary.main + " !important" },
        colorSecondaryLight: { color: palette.secondary.light + " !important" },
        colorSecondaryDark: { color: palette.secondary.dark + " !important" },
        colorSecondaryContrast: { color: palette.secondary.contrastText + " !important" },
        colorError: { color: palette.error.main + " !important" },
        colorErrorLight: { color: palette.error.light + " !important" },
        colorErrorDark: { color: palette.error.dark + " !important" },
        colorErrorContrast: { color: palette.error.contrastText + " !important" },
        colorCommonWhite: { color: palette.common.white + " !important" },
        colorCommonBlack: { color: palette.common.black + " !important" },
        colorBackground: { color: palette.background.default + " !important" },
        colorBackgroundPaper: { color: palette.background.paper + " !important" },
        colorText: { color: palette.text.primary + " !important" },
        colorTextSecondary: { color: palette.text.secondary + " !important" },
        colorTextHint: { color: palette.text.hint + " !important" },
        colorTextDisabled: { color: palette.text.disabled + " !important" },
        bgPrimary: { backgroundColor: palette.primary.main + " !important" },
        bgPrimaryLight: { backgroundColor: palette.primary.light + " !important" },
        bgPrimaryDark: { backgroundColor: palette.primary.dark + " !important" },
        bgPrimaryContrast: { backgroundColor: palette.primary.contrastText + " !important" },
        bgSecondary: { backgroundColor: palette.secondary.main + " !important" },
        bgSecondaryLight: { backgroundColor: palette.secondary.light + " !important" },
        bgSecondaryDark: { backgroundColor: palette.secondary.dark + " !important" },
        bgSecondaryContrast: { backgroundColor: palette.secondary.contrastText + " !important" },
        bgError: { backgroundColor: palette.error.main + " !important" },
        bgErrorLight: { backgroundColor: palette.error.light + " !important" },
        bgErrorDark: { backgroundColor: palette.error.dark + " !important" },
        bgErrorContrast: { backgroundColor: palette.error.contrastText + " !important" },
        bgCommonWhite: { backgroundColor: palette.common.white + " !important" },
        bgCommonBlack: { backgroundColor: palette.common.black + " !important" },
        bgBackground: { backgroundColor: palette.background.default + " !important" },
        bgBackgroundPaper: { backgroundColor: palette.background.paper + " !important" },
        bgText: { backgroundColor: palette.text.primary + " !important" },
        bgTextSecondary: { backgroundColor: palette.text.secondary + " !important" },
        bgTextHint: { backgroundColor: palette.text.hint + " !important" },
        bgTextDisabled: { backgroundColor: palette.text.disabled + " !important" }
    };
});
//# sourceMappingURL=Color.js.map